var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4928 17.0687C13.6246 17.0694 13.7552 17.0442 13.8772 16.9946C13.9992 16.9449 14.1102 16.8717 14.2038 16.7791C14.2976 16.6863 14.3721 16.5759 14.423 16.4542C14.4738 16.3326 14.5 16.2021 14.5 16.0703C14.5 15.9384 14.4738 15.8079 14.423 15.6863C14.3721 15.5646 14.2976 15.4542 14.2038 15.3614L10.8892 11.9991L14.2088 8.6367C14.3953 8.44963 14.5 8.19658 14.5 7.93281C14.5 7.66904 14.3953 7.41599 14.2088 7.22892C14.1157 7.13534 14.005 7.06107 13.8829 7.01038C13.7609 6.95969 13.63 6.93359 13.4978 6.93359C13.3656 6.93359 13.2347 6.95969 13.1127 7.01038C12.9907 7.06107 12.8799 7.13534 12.7868 7.22892L8.78626 11.3002C8.60277 11.4868 8.5 11.7377 8.5 11.9991C8.5 12.2604 8.60277 12.5113 8.78626 12.698L12.7918 16.7492C12.8817 16.846 12.9899 16.924 13.1102 16.9789C13.2306 17.0337 13.3606 17.0642 13.4928 17.0687Z",
    fill: "#1F85CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBlue);
export default __webpack_public_path__ + "static/media/ArrowLeftBlue.5129afe0f31999ad002cd90a734e3ecd.svg";
export { ForwardRef as ReactComponent };